import { useEffect, useState } from 'react';

export default function InputSelect({ placeholder, validationLabel, defaultValue = "", name, onChange, label, options }) {

    //activer onChange si onChange sans le focus

    const [valueAvailable, setValueAvailable] = useState(true);

    const nonValidStyle = {
        backgroundColor: "#dc35454d",
        borderBottom: "1px solid #dc3545"
    }

    const handleBlur = (e) => {
        if (e.target.value) onChange(e);
    }

    //Si defaultValue ne fait pas partie des options on change la valeur sur le placeholder
    useEffect(() => {
        const availableOptions = options.map((option) => parseInt(option.id));
        if (!availableOptions.includes(parseInt(defaultValue))) {
            setValueAvailable(false); // Définit la valeur par défaut si non valide
        } else {
            setValueAvailable(true);
        }
    }, [defaultValue, options]);

    return (
        <div className="relative w-full">
            <select className={"min-h-10 outline-none border-b border-[#504343] bg-[#f5f5f5] px-2 w-full text-md focus:bg-[#ebebeb] " + (valueAvailable ? "text-black" : "text-gray")} style={validationLabel ? nonValidStyle : {}} value={valueAvailable?defaultValue:""} name={name} onBlur={handleBlur} onChange={onChange}>
                <option className="text-gray" value="" disabled>{placeholder}</option>
                {options.map((item) => <option key={item.id} className="text-black" value={item.id}>{item.label}</option>)}
            </select>
            <label className="absolute top-0 right-1 text-red text-xs" htmlFor={name} >{validationLabel}</label>
            <p className="text-gray text-xs">{label}</p>
        </div>
    )
}